// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/build/css/" + chunkId + "." + "8c3d3a7b59b23e0d55ca" + ".css";
};